import { render, staticRenderFns } from "./StudioEventDetails.vue?vue&type=template&id=e44768a0&scoped=true&"
import script from "./StudioEventDetails.vue?vue&type=script&lang=js&"
export * from "./StudioEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudioEventDetails.vue?vue&type=style&index=0&id=e44768a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44768a0",
  null
  
)

export default component.exports